var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_73_426",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1482",
    d: "M28 0H0V28H28V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_73_426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 533",
    d: "M28.001 14.0005C28.0007 11.325 27.2338 8.70559 25.7911 6.45239C24.3483 4.19919 22.2901 2.40655 19.8602 1.28674C17.4303 0.16693 14.7305 -0.233181 12.0802 0.133789C9.42998 0.500759 6.94038 1.61944 4.90618 3.35738C2.87197 5.09533 1.37836 7.37975 0.602146 9.9402C-0.174066 12.5007 -0.200371 15.2299 0.526366 17.8049C1.2531 20.3798 2.70244 22.6926 4.70278 24.4694C6.70312 26.2462 9.17071 27.4126 11.8134 27.8306V18.0497H8.2598V14.0005H11.8134V10.9149C11.6763 9.61195 12.0623 8.30787 12.8864 7.28938C13.7105 6.27089 14.9054 5.62136 16.2083 5.48359C16.5055 5.45324 16.8049 5.44895 17.1028 5.47078C18.1528 5.48591 19.2002 5.57777 20.2367 5.74564V9.18297H18.4703C18.207 9.14777 17.9394 9.16476 17.6827 9.233C17.4259 9.30124 17.1852 9.41936 16.9741 9.58065C16.7631 9.74193 16.5859 9.94322 16.4526 10.173C16.3193 10.4028 16.2326 10.6566 16.1975 10.9199C16.1779 11.0691 16.1746 11.2201 16.1876 11.3701V13.9966H20.0732L19.4417 18.0408H16.1748V27.8237C19.4692 27.3046 22.4702 25.6266 24.6375 23.0918C26.8048 20.5569 27.9961 17.3317 27.997 13.9966",
    fill: "#2E4455"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbSvg);
export default __webpack_public_path__ + "static/media/fbSvg.b14dde8dda806d4b45d86c799cd70de2.svg";
export { ForwardRef as ReactComponent };